import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue"

import Button from "@/components/button.vue"
  import CustomerEditor from "@/components/editors/customer.vue"
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
  import Breadcrumb from "@/components/breadcrumb.vue"
  import {useRoute} from "vue-router"
  import {Customer as CustomerClient} from "@/endpoints/rutsolve/gql/resolvers/customer"
  import {ContactDetails as ContactDetailsClient} from "@/endpoints/rutsolve/gql/resolvers/contact_details"
  import {onBeforeMount, ref} from "vue"
  import {ContactDetails, Customer} from "@/endpoints/rutsolve/gql/generated/graphql"
  import ErrorModal from "@/components/modals/error.vue"
  import ConfirmationModal from "@/components/modals/confirmation.vue"
  import router from "@/router"
  import ContactDetailsList from "@/components/lists/contact_details.vue"
  import ContactDetailsEditor from "@/components/editors/contact_details.vue"
  import ContentModal from "@/components/modals/content.vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'edit_customer',
  setup(__props) {

  const error = ref<Error>(null)
  const contactDetailsClient = new ContactDetailsClient()
  const customerClient = new CustomerClient()
  const customer = ref<Customer>(null)
  const confirmRemove = ref<boolean>(false)
  const selectedContactDetails = ref<ContactDetails>(null)
  const selectedContactDetailsIndex = ref<number>(null)

  onBeforeMount(() => {
    read()
  })

  async function read() {
    try {
      const customerID = useRoute().params.customerID.toString()
      customer.value = await customerClient.summary(customerID)
      if (!customer.value.contactDetails || !customer.value.contactDetails.records) {
        customer.value.contactDetails = {
          records: []
        }
      }
    } catch(e) {
      error.value = e
    }
  }

  async function remove() {
    try {
      await customerClient.remove(customer.value.id)
      customersRedirect()
    } catch(e) {
      error.value = e
    }
  }

  async function save() {
    try {
      await customerClient.update(customer.value)
      for (const contactDetails of customer.value.contactDetails.records) {
        contactDetails.relationID = customer.value.id
        contactDetails.relationType = "CUSTOMER"
        if (contactDetails.deletedAt) {
          await contactDetailsClient.remove(contactDetails.id)
        } else if (contactDetails.id) {
          await contactDetailsClient.update(contactDetails)
        } else {
          await contactDetailsClient.create(contactDetails)
        }
      }
      customersRedirect()
    } catch(e) {
      error.value = e
    }
  }
  
  function customersRedirect() {
    router.push({
      name: "customers"
    })
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _createVNode(VerticalNavigator, null, {
        default: _withCtx(() => [
          (customer.value)
            ? (_openBlock(), _createBlock(Breadcrumb, {
                key: 0,
                links: [{
          title: 'RutSolve',
          routeName: 'index'
        }, {
          title: 'Customers',
          routeName: 'customers'
        }],
                title: customer.value.name
              }, null, 8, ["title"]))
            : _createCommentVNode("", true),
          _cache[12] || (_cache[12] = _createElementVNode("h1", null, " Edit Customer ", -1)),
          _createVNode(CustomerEditor, {
            value: customer.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((customer).value = $event))
          }, null, 8, ["value"]),
          _cache[13] || (_cache[13] = _createElementVNode("h2", null, " Contact Details ", -1)),
          (customer.value && customer.value.contactDetails)
            ? (_openBlock(), _createBlock(ContactDetailsList, {
                key: 1,
                items: customer.value.contactDetails.records,
                "onUpdate:items": _cache[1] || (_cache[1] = ($event: any) => ((customer.value.contactDetails.records) = $event)),
                selectedIndex: selectedContactDetailsIndex.value,
                "onUpdate:selectedIndex": _cache[2] || (_cache[2] = ($event: any) => ((selectedContactDetailsIndex).value = $event)),
                onSelect: _cache[3] || (_cache[3] = ($event: any) => (selectedContactDetails.value = customer.value.contactDetails.records[selectedContactDetailsIndex.value]))
              }, null, 8, ["items", "selectedIndex"]))
            : _createCommentVNode("", true),
          (selectedContactDetails.value)
            ? (_openBlock(), _createBlock(ContentModal, { key: 2 }, {
                default: _withCtx(() => [
                  _createVNode(ContactDetailsEditor, {
                    value: selectedContactDetails.value,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((selectedContactDetails).value = $event))
                  }, null, 8, ["value"]),
                  _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                  _createVNode(Button, {
                    title: "Apply",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (selectedContactDetails.value = null))
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(Button, {
            title: "Remove",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (confirmRemove.value = true))
          }),
          _createVNode(Button, {
            title: "Cancel",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (customersRedirect()))
          }),
          _createVNode(Button, {
            title: "Save",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (save()))
          })
        ]),
        _: 1
      }),
      _createVNode(ConfirmationModal, {
        display: confirmRemove.value,
        "onUpdate:display": _cache[9] || (_cache[9] = ($event: any) => ((confirmRemove).value = $event)),
        callback: remove,
        message: "This action will remove selected customer.",
        title: "Remove Customer"
      }, null, 8, ["display"]),
      (error.value)
        ? (_openBlock(), _createBlock(ErrorModal, {
            key: 0,
            error: error.value,
            "onUpdate:error": _cache[10] || (_cache[10] = ($event: any) => ((error).value = $event))
          }, null, 8, ["error"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})